const TotalIsZero = ({ query, minHeight = 0 }: any) => {
  return (
    <div data-testid="total-is-zero" className="mt-2.5">
      {query === 0 && (
        <div
          className="flex flex-wrap items-center bg-white rounded p-4"
          style={{ minHeight: minHeight }}
        >
          <div className="w-full">
            <p className="text-center text-gray-500 text-lg">
              هیچ داده ای یافت نشد!
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TotalIsZero;